/** Маска даты рождения: отображение ДД.ММ.ГГГГ, value — YYYY-MM-DD. */

export function formatBirthDigits(digits) {
  const d = String(digits || "").replace(/\D/g, "").slice(0, 8);
  let out = "";
  if (d.length > 0) out = d.slice(0, 2);
  if (d.length >= 2) out += ".";
  if (d.length > 2) out += d.slice(2, 4);
  if (d.length >= 4) out += ".";
  if (d.length > 4) out += d.slice(4, 8);
  return out;
}

export function isoToBirthDisplay(iso) {
  const s = String(iso || "").trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "";
  const [y, m, d] = s.split("-");
  return `${d}.${m}.${y}`;
}

function isValidIsoDate(iso) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return false;
  const [y, m, d] = iso.split("-").map(Number);
  if (y < 1900 || y > 2100) return false;
  const dt = new Date(y, m - 1, d);
  return (
    dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d
  );
}

/** Из строки/цифр/ISO → YYYY-MM-DD или null */
export function parseBirthDateToIso(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return isValidIsoDate(s) ? s : null;
  }
  const digits = s.replace(/\D/g, "");
  if (digits.length !== 8) return null;
  const dd = digits.slice(0, 2);
  const mm = digits.slice(2, 4);
  const yyyy = digits.slice(4, 8);
  const iso = `${yyyy}-${mm}-${dd}`;
  return isValidIsoDate(iso) ? iso : null;
}

export function formatBirthDateDisplay(value) {
  if (!value) return "";
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return isoToBirthDisplay(s);
  return formatBirthDigits(s);
}

export function isBirthDateComplete(value) {
  return Boolean(parseBirthDateToIso(value));
}
